import {useEffect} from 'react'
import { useMediaQuery } from 'react-responsive';

import {useLang} from '../../_metronic/i18n/Metronici18n'
import { DrawerComponent, MenuComponent } from '../../_metronic/assets/ts/components'

import { UserMenuDropdown } from '../components/UserMenuDropdown'
import { Footer } from '../components/Footer'

import {useLayout} from '../context/layout'

import { useAuth } from '../context/auth'

import UserSymbol from '../components/UserPicture';

const Aside = ({children, withVersion=false}) => {

  const { showAside } = useLayout();

  const isMobile = useMediaQuery({ maxWidth: 991.98 });

  const {currentUser} = useAuth()

  const selectedLang = useLang()

  useEffect(() => { 
    MenuComponent.reinitialization()
    if( isMobile ){
      DrawerComponent.createInstances('[data-kt-drawer="true"]')
    }
  }, [])

  return <div 
    className={`${isMobile ? 'drawer drawer-start w-300px' : 'mw-250px'} d-flex flex-column w-100 bg-body ${!isMobile && !showAside && 'd-none'}`}
    {...(isMobile && {
    "data-kt-drawer":'true',
    "data-kt-drawer-activate":'true',
    "data-kt-drawer-overlay":'true',
    "data-kt-drawer-direction":'start',
    'data-kt-drawer-toggle':'#aside-toggle'
    })}
  >
    {children}
    <div className="footer p-4 d-flex flex-column z-index-1 mt-auto">
      { isMobile && (
        <div className="d-flex flex-row mx-2">
          <div className="d-flex align-items-center w-100" >
            <UserSymbol picture={currentUser?.picture}/>
            <div className="fw-bold d-flex align-items-center fs-5 ms-3">
                {currentUser && currentUser.email}
            </div>
          </div>
          <div>
            <button className="btn btn-icon"  data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement={`top-${selectedLang == 'en' ? 'end' : 'start'}`}>
              <i className="fa-solid fa-ellipsis-h fs-2"></i>
            </button>
            <UserMenuDropdown/>
          </div>
        </div>
      )}
      <Footer withVersion={withVersion}/>
    </div>
  </div>
}

export {Aside}
